<template>
  <div class="signup-container auth-container">
    <header id="checkout-cadastro-titulo">
      <h1 v-t.preserve="'auth.signUp.title'" />
      <h2 v-t.preserve="'auth.signUp.subtitle'" />
    </header>
    <nav>
      <sign-up-email
        @authenticated="goToCheckout()"
        @email-form="isEmailForm = $event"
        key="signup_left"
        class="card card--rounded signup-container__left"
      />
      <div key="signup_or" class="or_partner" :style="!isEmailForm ? 'opacity: 0' : ''" >
        <hr />
        <span v-t.preserve="'auth.signUp.signUpMethodsSeparator'"/>
        <hr />
      </div>
      <transition name="fade" mode="out-in">
        <sign-up-partner
          v-if="isEmailForm"
          @partner-form="isPartnerForm = $event"
          @authenticated="goToCheckout()"
          key="signup_right"
          class="card card--rounded signup-container__right"
          :class="isPartnerForm ? 'partner-form' : ''"
        />
        <Kim v-else class="card card--rounded signup-container__right" />
      </transition>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SignUpContainer',
  data () {
    return {
      isEmailForm: true,
      isPartnerForm: false
    }
  },
  methods: {
    goToCheckout () {
      this.$router.push({ name: 'checkout', params: { ...this.$route.params }, query: { ...this.$route.query } })
    }
  }
}
</script>

<style lang="scss" scoped>
.signup-container {
  >header {
    width: 100%;
    @media ($screen-md) {
      width: 50%;
    }
  }
  nav {
    width: 100%;
    position: relative;
    display: block;
    @media ($screen-md) {
      display: flex;
    }
  }
  .partner-form {
    @media ($screen-md) {
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
    }
  }
  &__left {
    width: 100%;
    @media ($screen-md) {
      width: 55%;
    }
  }
  &__right {
    transition: all 100ms;
    z-index: 8;
    width: 100%;
    @media ($screen-lg) {
      width: 45%;
    }
  }
  .or_partner {
    text-align: center;
    width: 80px;
    color: #606568;
    font-size: 24px;
    margin: 0 1rem;
    font-weight: 900;
    hr {
      width: 0;
      height: calc(45% - 12px);

    }
    @media ($screen-xs) {
      display: flex;
      width: 100%;
      align-items: center;
      margin: 1rem 0;
      hr {
        height: 0;
        width: 45%;
        margin: 0 4%;
      }
    }
  }
}
</style>
